/* eslint-disable */
import React from 'react';
import { useParams } from 'react-router-dom';
import { useStore } from '../../../../store';
import { useUpdateComponentState } from '../../../hooks';
import TopicContainer from '../TopicContainer';
import TopicItem from '../TopicItem';
import TopicIntroContent from '../TopicIntroContent';
import ContentBlocks from '../ContentBlocks';
import { getCivilIcon } from '../CivilIcons';
import './index.less';

export interface IModuleTopicProps {
  /** 当前 topic 的 JSON 设置（含 paragraphs） */
  settings: any;
  /** 模块标识，用于 landing video 的 DOM id */
  moduleKey: string;
}

/**
 * civil 各培训模块共用的 topic 骨架：
 * paragraphs[0] 为「引言 + 视频」，其余段落按 blocks 数组渲染内容组件。
 */
const ModuleTopic: React.FunctionComponent<IModuleTopicProps> = ({
  settings,
  moduleKey,
}) => {
  const param = useParams();
  const p_course = param.course || '';
  const p_topic = param['*'] || 'welcome';
  const { updateParagraphState } = useStore();
  const updateComponentState = useUpdateComponentState();

  const paragraphs = settings?.paragraphs || [];
  const intro = paragraphs[0];
  const contentParagraphs = paragraphs.slice(1);

  React.useEffect(() => {
    if (!intro) return;
    updateParagraphState(p_course, p_topic, intro.id, 'completed', []);
  }, []);

  return (
    <TopicContainer className="course-module">
      {intro && (
        <TopicItem id={intro.id}>
          <div className="course-landing">
            <div className="course-landing-content">
              <TopicIntroContent
                title={intro.header}
                icon={getCivilIcon(intro.icon)}
                description={intro.description}
                landingVideo={intro.landingVideo}
                transcripts={intro.transcripts}
                videoId={`video-${moduleKey}`}
              />
            </div>
          </div>
        </TopicItem>
      )}
      {contentParagraphs.map((paragraph: any, index: number) => (
        <TopicItem
          key={paragraph.id}
          id={paragraph.id}
          className={`topic-item module_${index + 2}`}
        >
          <div className="module-section">
            <ContentBlocks
              blocks={paragraph.blocks}
              onComponentComplete={(componentId) =>
                updateComponentState(p_course, p_topic, paragraph.id, componentId)
              }
            />
          </div>
        </TopicItem>
      ))}
    </TopicContainer>
  );
};

export default ModuleTopic;
